<script lang="ts">
    import CandidateInfoHeader from "./CandidateInfoHeader.svelte"
    import CandateExperience from './CandidateExperience.svelte'
    import CandidateSkills from "./CandidateSkills.svelte";
    import InfoPill from "./InfoPill.svelte";
    import { assets as assetPath } from '$app/paths'

    export let candidate
    export let searchTerm : string = ''
    export let roleSearchTerm : string = ''
    export let handleShowPopUp
    export let currency : string
    export let totalCandidates : number | null = null
    export let index : number
 
    const { skills, location, role_experiences, salary} = candidate._source
    const { profilePicture } = candidate

    let sortedRoles = role_experiences
    let locationCities = location.map(loc => {
        return loc.cities
    }).flat()

    if(roleSearchTerm) {
        sortedRoles = [
            ...role_experiences.filter(role => role.name === roleSearchTerm), 
            ...role_experiences.filter(role => role.name !== roleSearchTerm)
        ]
    }
</script>

<div class="candidate-preview-card" on:click={handleShowPopUp({
    [`profile_skills_${index}`]: skills.toString(),
    skills_filter: searchTerm,
    roles_filter: roleSearchTerm,
    [`salary_eur_annual_${index}`]: salary?.eu,
    [`salary_zar_annual_${index}`]: salary?.za,
    [`wants_to_work_in_${index}`]: locationCities.toString(),
    results: totalCandidates,
})}>
    <InfoPill text="New this week" theme="green-dark" className="candidate-preview-card__pill"/>
    <CandidateInfoHeader
        image='{assetPath}/assets/profiles/{profilePicture}'
        title={sortedRoles[0].name}
        secondaryCopy='Prefers {currency === 'ZAR' ? 'R' : '€'}{currency === 'ZAR' ? salary?.za : salary?.eu}/{currency === 'ZAR' ? 'month' : 'year'}'
        locations={location}
    />
    <CandateExperience
        experiences={sortedRoles}
        {roleSearchTerm}
    />
    <CandidateSkills 
        {skills} 
        {searchTerm}
    />
    <button class="candidate-preview-card__button">View candidate</button>
</div>

<style lang="postcss">
    .candidate-preview-card {
        display: flex;
        flex-direction: column;
        color: rgb(124, 124, 128);
        width: 100%;
        margin: auto auto 12px;
        border: 1px solid rgb(228, 235, 239);
        max-width:400px;
        cursor: pointer;
        transition: all 0.2s ease-in-out 0s;
        padding:24px;
        box-shadow: rgba(0, 0, 0, 0.1) 1px 1px 5px;
        background-color: var(--color_white);
        height:100%;


        & :global(.candidate-preview-card__pill) {
            align-self: flex-end;
        }

        & :global(h3), & :global(h4) {
            color: var(--color_offerzen_black);
            font-size:18px;
            margin:0 0 12px;
        }

        & h5 {
            font-size:14px;
            font-weight:600;
            color:var(--color_grey_tertiary);
        }

        & .candidate-preview-card__button { 
            display: flex;
            font-size: 16px;
            -webkit-box-align: center;
            align-items: center;
            width: 100%;
            -webkit-box-pack: center;
            justify-content: center;
            border-radius: 6px;
            border: 1px solid rgb(94, 165, 238);
            color: rgb(94, 165, 238);
            line-height: 1.4;
            padding: 6px 12px;
            background: transparent;
            cursor: pointer;
            height: 45px !important;
            pointer-events: none;
            margin-top:auto;
        }
    }

    .candidate-preview-card:hover {
        transform: scale(1.03);
    }

    .candidate-preview-card:hover :global(.candidate-preview-card__button) {
        background-color: #5ea5ee;
        color:var(--color_white);
    }

</style>